import { styled } from "leva/plugin";
import { motion } from "framer-motion";
import { hexToRgba } from "../utilities/hexToRGBA";

export const StyledNotification = styled(motion.div, {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	backgroundColor: hexToRgba("#171718", 0.92),
	padding: "0.5rem 1rem",
	borderRadius: "0.375rem",
	borderWidth: "1px",
	marginBottom: "0.5rem",
	cursor: "pointer",
	position: "relative",
	variants: {
		type: {
			error: {
				width: "100%",
				borderColor: "red",
			},
			success: {
				borderColor: "gray-600",
			},
			info: {
				width: "100%",
				borderColor: "purple",
			},
		},
		hover: {
			true: {
				backgroundColor: hexToRgba("#171718", 0.97),
			},
		},
	},
});

export const NotificationTitle = styled("h2", {
	textAlign: "center",
	color: "white",
});

export const NotificationMessage = styled("p", {
	color: "rgba(255, 255, 255, 0.75)",
	fontSize: "0.8rem",
});

export const NotificationLink = styled("button", {
	textAlign: "center",
	color: "#60a5fa",
	fontWeight: "500",
	"&:hover": {
		color: "#3b82f6",
	},
});

export const NotificationCloseButton = styled("div", {
	position: "absolute",
	top: "4px",
	right: "8px",
	cursor: "pointer",
	color: "$highlight1",
	"&:hover": {
		color: "red",
	},
});
